module.exports = __webpack_public_path__ + "img/logo.fc710d30.png";